/*Clase que representa la entidad de respuestas finales del usuario evaluado*/
export class RevisionRespuestas {

    /**	representa id del usuario prueba */
	public idUsuario: number = 0;
	
	/** representa el snp del usuario */
	public snpUsuario: string = "";
	
	/** representa id de la prueba */
	public idPrueba: number = 0;
	
	/** representa el orden de las preguntas de la prueba */
	public ordenPregunta: number = 0;
	
	/**	representa la respuesta marcada por el usuario en la prueba */
	public answerUser: string  = "";	
	 
	/**	representa la respuesta correcta de la prueba */
	public answerCorrecta: string = "";	

	/**	representa el resultado acertado o no acertado de la respuesta */
	public result: number = 0;
	
	/**	obtiene el idItem de las preguntas de la prueba */
	public idItem: number = 0;


}
